import FeedbackReplyForm from './FeedbackReplyForm'
import {invoiceReceiptDateTime} from 'utils/formatter'
import styles from './style.detail.css'

class FeedbackReply extends React.Component {
  render () {
    let {
      feedbackMessages,
      onSubmit,
      feedbackType,
      feedbackMode
    } = this.props

    return (
      <div className='col-sm-6 no-padding-left' id='mk-col-left'>
        <div className='mk-feed-box'>
          <div className={styles['header-feed']}>
            <div className={styles['title-truncate']}>
              {(feedbackMode === 'happy')
                ? <i className='fa fa-smile-o pull-left' />
                : <i className='fa fa-frown-o pull-left' />
              }
              <span>
                {feedbackType}
              </span>
            </div>
          </div>
          <div className='feed-scrolled-area feedback-list-page'>
            <div className={styles['stream-feed-box']}>
              {
                feedbackMessages.messages.map((feedbackDetail, idx) => {
                  return (
                    <div key={idx}>
                      {feedbackDetail.is_customer
                      ? <div className='left-feed-box'>
                        <div className='img-profile'>
                          <img src={require('assets/images/account-profile-default.jpg')} alt='account profile default' />
                        </div>
                        <div className='bubble-text'>
                          {feedbackMessages.feedback_from === 'sms' && <div className='name'>
                            {feedbackMessages.customer_phone}
                          </div>}
                          {feedbackMessages.feedback_from !== 'sms' && <div className='name'>
                            {feedbackDetail.name || feedbackDetail.email}
                          </div>}
                          <div className='feed'>
                            {feedbackDetail.comment}
                          </div>
                        </div>
                        <div className='time'>
                          <i className='fa fa-clock-o' />
                          {invoiceReceiptDateTime(feedbackDetail.created_at, 'datetime')}
                        </div>
                      </div>
                      : <div className='right-feed-box'>
                        {(feedbackMessages.business_logo_url)
                          ? <div className='img-profile'>
                            <img src={feedbackMessages.business_logo_url} />
                          </div>
                          : <div className='img-profile'>
                            <img src={require('assets/images/account-profile-default.jpg')} />
                          </div>
                        }
                        <div className='bubble-text'>
                          <div className='name'>
                            {feedbackMessages.business_name}
                          </div>
                          <div className='feed'>
                            {feedbackDetail.comment}
                          </div>
                        </div>
                        <div className='time'>
                          <i className='fa fa-clock-o' />
                          {invoiceReceiptDateTime(feedbackDetail.created_at, 'datetime')}
                        </div>
                      </div>
                    }
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className={styles['footer-feed']}>
            <FeedbackReplyForm onSubmit={onSubmit} feedbackfrom={feedbackMessages.feedback_from} />
          </div>
        </div>
      </div>
    )
  }
}

FeedbackReply.propTypes = {
  feedbackMessages: React.PropTypes.object,
  onSubmit: React.PropTypes.func,
  feedbackType: React.PropTypes.string,
  feedbackMode: React.PropTypes.string
}

export default FeedbackReply



// WEBPACK FOOTER //
// ./app/pages/Customers/Feedback/FeedbackDetail/FeedbackReply.js